import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import dimissColumnTemplate from './dismiss-column-template.pug';

/**
 * Displays dismiss column.
 */

export class Dismiss extends ProjectionGridBaseColumn {
  constructor({ deps, columnOverrider, gridRemoveAll }) {
    super({
      name: 'Dismiss',
      property: 'Performance',
      title: gridRemoveAll ? 'Location_Target_Grid_RemoveColumn' : ' ',
      i18n: deps.i18n,
      headClasses: gridRemoveAll ? ['recommendation-target-grid__removeall-header', 'text-right'] : [''],
      bodyClasses: ['text-right'],
      colClasses: ['col-selection'],
      html: gridRemoveAll ? `<a href='javascript:void(0)'><span>${deps.i18n.getString('Location_Target_Grid_RemoveColumn')}</span></a>` : '',
      ...columnOverrider.Dismiss,
    });
    this.deps = deps;
  }

  template() {
    return dimissColumnTemplate({
      i18n: this.deps.i18n,
    });
  }
}
